import { useEffect, useState } from "react";

const navItems = [
  { href: "#overview", label: "生态速览" },
  { href: "#categories", label: "内容领域" },
  { href: "#creators", label: "创作者速览" },
  { href: "#ranking", label: "精选榜" },
  { href: "#rising", label: "新锐力量" },
  { href: "#guide", label: "选博主指南" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-[72px] items-center justify-between">
          <a href="#top" className="flex items-center gap-2.5 group">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-clapperboard-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-base md:text-lg font-bold ${
                  scrolled || menuOpen ? "text-foreground-950" : "text-background-50"
                }`}
              >
                西瓜视频网红名单
              </span>
              <span className={`mt-0.5 hidden md:block text-[11px] ${scrolled || menuOpen ? "text-foreground-500" : "text-background-200"}`}>
                创作者 · 主播 · 大V · 达人速览
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  scrolled
                    ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                    : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href="#creators"
            className="hidden lg:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-eye-line"></i>
            开始找博主
          </a>

          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden flex h-10 w-10 items-center justify-center rounded-md ${
              scrolled || menuOpen ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}